import { useMemo } from "react";
import { useAccountRoleCheck } from "@/modules/account/hooks/useAccountRoleCheck";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";

const ROLES_WITH_PRESENTATION_IMAGE_COUNT_ACCESS = [
  SYSTEM_ROLE_CODE.OPERATIONAL_DIRECTOR,
  SYSTEM_ROLE_CODE.HR_DEPARTMENT,
  SYSTEM_ROLE_CODE.CONTROL_AND_REPORTS,
  SYSTEM_ROLE_CODE.SYSTEM_ADMINISTRATOR,
] as const;

export function useContestAgreementsFieldPermissions() {
  const { hasAnyRole } = useAccountRoleCheck();

  return useMemo(
    () => ({
      canSeePresentationImageCount: hasAnyRole(
        ROLES_WITH_PRESENTATION_IMAGE_COUNT_ACCESS,
      ),
    }),
    [hasAnyRole],
  );
}
